import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Output, signal } from '@angular/core';
import { IconTypes } from '@shared/v2';
import { SdvorIconComponent } from '../../../icon';

@Component({
  selector: 'sd-accordion-label',
  imports: [SdvorIconComponent],
  templateUrl: './accordion-label.component.html',
  styleUrls: ['./accordion-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdAccordionLabelComponent {
  iconTypes = IconTypes;
  opened = signal(false);
  @Output() clicked = new EventEmitter<void>();

  @HostListener('click')
  onClick(): void {
    this.clicked.emit();
  }
}
